import React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'

import theme from '@app/ui/theme'
import { HEADER_HEIGHT } from '@app/ui/theme/constants'

export interface SubListLinkProps {
  isOpen: boolean
  mouseLeave: () => void
  mouseEnter: () => void
  children?: React.ReactNode
  rightOffset?: number
  linksOnly?: boolean
}

const SubMenuContainerStyled = styled.nav<SubListLinkProps>`
  padding: 3rem;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  background-color: ${({ theme }) => `${theme.global.colors.floralWhite}`};
  border: 0.1rem solid ${({ theme }) => `${theme.global.colors.halfSpanishWhite}`};
  border-radius: 0.5rem;
  min-width: 18rem;
  top: calc(100% + 1.1rem);
  right: ${({ rightOffset }) => rightOffset}rem;

  @media ${theme.device.laptopL} {
    padding: 2rem;
  }

  ${({ linksOnly }) => {
    if (!linksOnly) {
      return `@media (max-width: 1210px) {
      position: fixed;
      right: 0;
      left: 0;
      top: ${HEADER_HEIGHT}rem;
    }`
    } else {
      return ''
    }
  }}
`

const AnimatedContainer = animated(SubMenuContainerStyled)

const SubMenuContainer = ({
  isOpen,
  children,
  rightOffset = 10,
  mouseLeave,
  mouseEnter,
  linksOnly = false
}: SubListLinkProps) => {
  const fadeIn = useSpring({ opacity: isOpen ? 1 : 0.6 })

  return (
    <AnimatedContainer
      {...{
        rightOffset,
        isOpen,
        linksOnly
      }}
      onMouseLeave={mouseLeave}
      onMouseEnter={mouseEnter}
      style={fadeIn}>
      {children}
    </AnimatedContainer>
  )
}

export default SubMenuContainer
